import React, { FC } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LinkButton } from '@adsk/alloy-react-button';
import theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';
import i18n from '../utils/i18n';

const RemoteOverridesPanelContainer = styled.div({
  height: 18,
  lineHeight: '18px',
  fontSize: 12,
  padding: '0px 8px',
  color: theme.colors.white,
  backgroundColor: theme.colors.green300,
});

type RemoteOverridePanelProps = {
  url: string;
  scope: string;
  onResetClick: () => void;
};

const RemoteOverridePanel: FC<RemoteOverridePanelProps> = ({
  url,
  scope,
  onResetClick,
}) => {
  return (
    <RemoteOverridesPanelContainer>
      <Tooltip
        content={url}
        placement={Tooltip.PLACEMENTS.BOTTOM}
        shouldWrapChildren={false}
      >
        {`${scope} ${i18n.t('USING_REMOTE_OVERRIDE')} | `}
        <LinkButton
          data-testid={`${scope}-reset`}
          style={{ cursor: 'pointer', fontSize: 12 }}
          onClick={onResetClick}
        >
          {i18n.t('RESET')}
        </LinkButton>
      </Tooltip>
    </RemoteOverridesPanelContainer>
  );
};

RemoteOverridePanel.propTypes = {
  url: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
  onResetClick: PropTypes.func.isRequired,
};

export default RemoteOverridePanel;
